import WebinarBanner, {
  BannerSpec,
} from '@invideoio/web-shared/components/WebinarBanner';
import { useAnnouncementBanners } from '@store/announcementBanners';
import { sendAmplitudeAnalyticEvent } from '@utils/analytics';

// The banner rotates through several slides, so the event is labelled with the
// slide that was actually clicked rather than assuming the webinar one.
const handleBannerClick = (spec: BannerSpec) =>
  sendAmplitudeAnalyticEvent('webinar_register_clicked', {
    ux_source: 'landing-page-banner',
    cta: spec.analyticsCta,
  });

// Thin consumer wrapper around the shared WebinarBanner that wires Amplitude.
// Accepts (and ignores) `browser` so it's a drop-in for the StudioBanner call sites.
const LandingWebinarBanner = (_props: { browser?: unknown }) => {
  // CMS-driven slides, provided by _app.
  //
  // `null` means no answer from the CMS: leave the prop unset so WebinarBanner
  // renders its own hardcoded default slides. An empty array means the CMS said
  // "no bar" and is passed straight through — the component renders nothing for
  // an empty list.
  const banners = useAnnouncementBanners();

  return (
    <WebinarBanner banners={banners ?? undefined} onClick={handleBannerClick} />
  );
};

export default LandingWebinarBanner;
